import React, { Suspense, useState, useEffect  } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Dialog } from 'antd-mobile';

import './App.css';
import routers from "./routers";
import NotFoundPage from '@/components/404Page';
import RouteGuard from '@/components/RouteGuard';
import useLogoutTimer from '@/hooks/useLogoutTimer';
import NetworkConnectedStatus from '@/components/NetworkConnect';
import { getRoleFromLocation } from '@/utils/commonUtils';
import EventEmitter from '@/utils/eventEmitter';
import CustomDialog from './components/CustomDialog';

function App() {
  // 注册监听器，判断是否有在使用
  useLogoutTimer();
  const role = getRoleFromLocation();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [logoutTimer, setLogoutTimer] = useState(null);

  useEffect(() => {
    const handleLogout = () => {
      Dialog.clear();
      setShowLogoutConfirm(true);
      setCountdown(10);  // 重置倒计时
      // 创建倒计时定时器
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            handleConfirmLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      setLogoutTimer(timer);
    };

    EventEmitter.on('confirmLogout', handleLogout);

    return () => {
      EventEmitter.off('confirmLogout', handleLogout);
      if (logoutTimer) clearInterval(logoutTimer);
    };
  }, [logoutTimer]);

   // 确认登出
   const handleConfirmLogout = () => {
    // 清除定时器
    if (logoutTimer) clearInterval(logoutTimer);
    // 退出逻辑
    EventEmitter.emit('robotLogout')
  };

  // 取消登出
  const handleCancelLogout = () => {
    // 清除定时器
    if (logoutTimer) clearInterval(logoutTimer);
    setShowLogoutConfirm(false);
    EventEmitter.emit('resetTimer')
  };

  function renderRouter(router, index) {
    if (router.children) {
      return (
        <Route
          path={router.path}
          element={
            router.needInterceptor
              ? (
                <RouteGuard role={role}>
                  <Suspense fallback={<div>Loading...</div>}>
                    {router.component}
                  </Suspense>
                </RouteGuard>
              )
              : (
                <Suspense fallback={<div>Loading...</div>}>
                  {router.component}
                </Suspense>
              )
          }
          key={index}
        >
          {
            router.children.map(item => renderRouter(item))
          }
        </Route>
      )
    }
    return (
      <Route
        key={router.path}
        path={router.path}
        element={
          router.needInterceptor
            ? (
              <RouteGuard role={role}>
                <Suspense fallback={<div>Loading...</div>}>
                  {router.component}
                </Suspense>
              </RouteGuard>
            )
            : (
              <Suspense fallback={<div>Loading...</div>}>
                {router.component}
              </Suspense>
            )
        }
        index={router.index === 'true'}
      />
    )
  }

  function renderLogoutHint () {
    return (
      <>
        <div>{`您已3分钟没有操作，系统将在${countdown}秒后自动登出。`}</div>
        <div>如需继续使用，请点击【继续访问】</div>
      </>
    )
  }

  return <>
    <Router>
      <Routes>
        {
          routers.map((router, index) => renderRouter(router, index))
        }
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <NetworkConnectedStatus />
    </Router>
    <CustomDialog 
      visible={showLogoutConfirm} 
      title='提醒'
      content={renderLogoutHint()}
      showCancelButton={false}
      confirmText={`继续访问(${countdown}秒)`}
      onConfirm={handleCancelLogout}
    />
  </>
}

export default App;
